// extracted by mini-css-extract-plugin
export var actions = "_qs-4";
export var item = "_qs-1";
export var price = "_qs-3";
export var quantity = "_qs-2";
export var table = "_qs-0";